import React from "react";

export default function JS_OOPs_Examples() {
  return (
    <div className="tutorial-container">
      <h1>JS OOPs Examples</h1>
      <p>
        This tutorial explains the concept of JS OOPs Examples in JavaScript
        OOPs.
      </p>
    </div>
  );
}
